/**
 * Determine if the code is executing in a testing environment.
 * @public
 * @returns True if the code is executing in a testing environment.
 */
export function isTestEnv() {
    return 'jasmine' in window || 'jest' in window || navigator.userAgent.includes('jsdom');
}
